import React, { useEffect, useState } from 'react';
import { Bell } from 'lucide-react';
export function AnnouncementBar() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 59); // 14:59 in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full bg-dusty-rose text-white py-3 px-4 shadow-md" data-id="element-11">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center text-center sm:text-left gap-2 sm:gap-4 text-sm sm:text-base font-medium" data-id="element-12">
        <div className="flex items-center gap-2" data-id="element-13">
          <Bell className="w-5 h-5 animate-pulse" data-id="element-14" />
          <span data-id="element-15">
            OFERTA DE LANZAMIENTO: Consigue el Pack Completo de 28 Días por solo
            $14.99{' '}
            <span className="line-through opacity-80 text-xs ml-1" data-id="element-16">
              (Precio real $197)
            </span>
          </span>
        </div>
        <div className="flex items-center gap-2 bg-white/20 px-3 py-1 rounded-full backdrop-blur-sm" data-id="element-17">
          <span data-id="element-18">— Vence en</span>
          <span className="font-bold font-mono tracking-wider" data-id="element-19">
            {formattedTime} min
          </span>
        </div>
      </div>
    </div>;
}